import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { ReplaySubject, takeUntil } from 'rxjs';
import { ThemeService } from '@wind-log_library/fe-component-library';
import { LogoService } from '@services/logo-service/logo.service';
@Component({
  selector: 'app-portfolio-icon',
  templateUrl: './portfolio-icon.component.html',
  styleUrls: ['./portfolio-icon.component.scss'],
})
export class PortfolioIconComponent implements OnChanges, OnDestroy {
  @Input() portfolioName: string | undefined;
  @Input() width = 40;

  private idPortfolio: string | undefined;
  public imageName: any;

  private unsubscriber = new ReplaySubject();

  constructor(
    private themeService: ThemeService,
    private logoService: LogoService,
  ) {
    this.themeService
      .getTheme()
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(() => {
        this.calcImageName();
      });
    this.calcImageName();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes?.['portfolioName']?.currentValue) {
      this.idPortfolio = this.portfolioName === '1' ? '99' : this.portfolioName;
      this.calcImageName();
    }
  }

  public ngOnDestroy(): void {
    this.unsubscriber.next(true);
    this.unsubscriber.complete();
  }

  public calcImageName() {
    this.imageName = this.logoService.getPortfolioLogo(this.idPortfolio);
  }
}
